import { render, staticRenderFns } from "./Daping.vue?vue&type=template&id=2357edc8&scoped=true&"
import script from "./Daping.vue?vue&type=script&lang=js&"
export * from "./Daping.vue?vue&type=script&lang=js&"
import style0 from "./Daping.vue?vue&type=style&index=0&id=2357edc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2357edc8",
  null
  
)

export default component.exports